/**
 * Converts text to a human-readable Title Case label.
 */
export const formatTitleCase = (text: string): string => {
  return text
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters (for camelCase)
    .replace(/_/g, ' ') // Replace underscores with spaces (for snake_case)
    .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()); // Title Case
};

/**
 * Converts standard snake case text back to classic name format.
 * @param {string} snake_case_text Original snake case formatted text to convert.
 * @returns {string}
 */
export const snakeCaseToTitleCase = (snake_case_text: string): string => {
  const word_list: Array<string> = snake_case_text.split('_');
  const name_text: string = word_list.map((word: string) => formatTitleCase(word)).join(' ');
  return name_text;
};

/**
 * Helper to more concisely get values from indexable record object.
 * @param {Record<string, T>} record Record to parse for values.
 * @returns {Array<T>}
 */
export const values = <T>(record: Record<string, T>): Array<T> => Object.values(record);
